<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main" v-loading="isLoading">
          <ucMenu num="1"></ucMenu>
          <div class="right_con">
            <div class="dianpu_main">
              <div class="dp_title">
                <p class="fb">我的店铺</p>
                <div class="auth_btn">
<!--                  <p class="add_new" @click="openRecord">充值记录</p>-->
                  <!-- 批量操作栏 -->
                  <p class="add_new" @click="openAddShop">{{ searchData.shop_type===1 ? '新增抖店' : '新增微信' }}</p>
                </div>
              </div>

              <!-- 店铺类型切换：1 抖店，7 微信；默认抖店 -->
              <div class="tabs_wrap">
                <p class="tab" :class="searchData.shop_type===1 ? 'active' : ''" @click="bindShopTypeChange(1)">抖店</p>
                <p class="tab" :class="searchData.shop_type===7 ? 'active' : ''" @click="bindShopTypeChange(7)">微信</p>
              </div>
              <div class="action-row">
                <el-radio-group class="radio_wrap" size="small" v-model="searchData.expire_status" @click.native="handleRadioClick">
                    <el-radio-button label="1">全部失效</el-radio-button>
                    <el-radio-button label="2">上货应用失效</el-radio-button>
                    <el-radio-button label="3">订单应用失效</el-radio-button>
                </el-radio-group>
                <div v-if="is_host" class="group-action">
                    <span class="group-label">分组管理：</span>
                    <el-button size="small" @click="selectAll">全选</el-button>
                    <el-button size="small" @click="unSelectAll">反选</el-button>
                    <el-button size="small" :disabled="selectedShopIds.length === 0" @click="openBatchGroupDialog">设置分组</el-button>
                    <el-button size="small" @click="openShopGroupManageDialog">分组管理</el-button>
                </div>
              </div>

              <div class="action-row">
                <span class="group-label">主营类目：</span>
                <el-select size="mini" v-model="searchData.main_category" clearable multiple collapse-tags placeholder="全部"  class="w220"  @change="setChange">
                   <el-option
                    v-for="(value, id) in main_category_list"
                    :key="id"
                    :label="value"
                    :value="id"
                    >
                    </el-option>
                </el-select>
                <!-- <el-dropdown size="mini" split-button>
                    全部
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            v-for="(value, id, index) in main_category_list"
                            :key="id"
                        >
                            {{ value }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
                <span class="group-label">分组：</span>
                <el-select size="mini" v-model="searchData.shop_groupids" class="w220" multiple clearable collapse-tags placeholder="全部分组" @change="setChange">
                  <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
                  <el-option v-if="is_host" label="未分组" value="-1">未分组</el-option>
                </el-select>
                <span class="group-label">店铺名：</span>
                <el-input size="mini"  class="w220" v-model="searchData.shop_name" placeholder="请输入店铺名" value="" @change="setChange"></el-input>
              </div>


              <ul class="dp_list">
                <li v-for="(item,index) in list" :key="index">
                  <div class="dp_list-header">
                    <div class="logo">
                        <img class="coverimg" v-if="searchData.shop_type==1" src="../../assets/images/logo.png"/>
                        <img class="coverimg" v-if="searchData.shop_type==7" src="../../assets/images/wechatshop.png"/>
                    </div>
                    <div style="flex: 1">
                      <div class="d-b-c">
                        <p class="dp_name">{{ item.shop_name }}</p>
                        <div class="d-b-c">
                          <el-tooltip :content="item?.vip?.name??''" class="item" effect="dark" placement="top">
                            <img :src="item.vip.icon_url" style="width: 24px;height: 24px" v-if="item?.vip?.icon_url"/>
                          </el-tooltip>

                          <template v-if="item.shop_vip_type==1">
                            <p class="vip_name" style="margin-top: 0;"><a
                                :href="'./shop_vip?menuId=0&shop_id='+item.shop_id" class="vip_btn">升级</a></p>
                          </template>
                          <template v-else-if="item.shop_vip_type==3 && item.share_vip_shop_name==item.shop_name">
                            <p class="vip_name" style="margin-top: 0;"><a
                                :href="'./shop_vip?menuId=0&shop_id='+item.shop_id" class="vip_btn">升级</a></p>
                          </template>
                        </div>
                      </div>

<!--                        <div class="add_btn" @click="$refs.orderMember.open(item)">订购会员</div>-->
                        <!-- <div style="display: flex; align-items: center; gap:6px; margin-top:5px;">
                            <p class="dp_name" style="margin:0 0 0 5px; font-size: 12px;">主营类目：</p>
                            <el-dropdown size="mini" split-button>
                                {{ item.shop_category_main_name && item.shop_category_main_name.length ? item.shop_category_main_name[0] : '未配置盲盒' }}
                                <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-for="(item, index) in item.shop_category_main_name"
                                    :key="index"
                                >
                                    {{ item }}
                                </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div> -->
                        <div style="display: flex; align-items: center; gap:6px; margin-top:5px;">
                            <p class="dp_name" style="margin:0 0 0 5px; font-size: 12px;">主营类目：</p>
                            <el-dropdown size="mini" trigger="hover">
                                <span>
                                <el-tag
                                    type="primary"
                                    size="small"
                                    style="display: flex; align-items: center; gap:3px; cursor: pointer;"
                                >
                                    {{ item.shop_category_main_name && item.shop_category_main_name.length ? item.shop_category_main_name[0] : '未配置盲盒' }}
                                    <i class="el-icon-arrow-down el-icon--right" style="font-size: 10px;"></i>
                                </el-tag>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-for="(name, index) in item.shop_category_main_name"
                                    :key="index"
                                >
                                    {{ name }}
                                </el-dropdown-item>
                                <!-- 空数据时显示 -->
                                <el-dropdown-item v-if="!item.shop_category_main_name || item.shop_category_main_name.length === 0">
                                    未配置盲盒
                                </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>

                    <div class="header-right">
                        <el-tag v-if="item.group_name" size="mini" type="success">{{ item.group_name }}</el-tag>
                        <el-tag v-else size="mini" type="info">未分组</el-tag>
                        <el-checkbox v-if="is_host" v-model="selectedShopIds" :key="item.shop_id" :label="item.shop_id">{{''}}</el-checkbox>
                    </div>
                </div>
                  <el-card class="con_box" :body-style="{padding:'8px'}">
                    <p>商品应用：{{ item.goods_app_name?item.goods_app_name:'未订购' }}</p>
                    <p v-if="searchData.shop_type===1">授权状态：
                      <span class="green" v-if="item.app_product_status==1">正常</span>
                      <span class="red" v-if="item.app_product_status==2">异常</span>
                    </p>
                    <p v-if="searchData.shop_type===7">授权状态：
                      <span class="green" v-if="item.status==1">正常</span>
                      <span class="red" v-if="item.status==2">异常</span>
                    </p>
                    <p>到期时间：{{ item.app_expire_time?formatTime(item.app_expire_time):'未订购' }}</p>
<!--                    <p>铺货额度：剩余 {{ item.quota_num }} / 总 {{ item.total_quota_num }}</p>-->
                    <p v-if="item.dd_resources_state!=1" class="dp_waring">素材库容量不足：
                      <span class="red" style="cursor: pointer;" @click="bindResourceState(item.shop_id)">重置</span>
                      <i class="el-icon-warning" style="cursor: pointer;color: #999;margin-left: 5px;" @click="bindResourceTips()"></i>
                    </p>
                    <div class="con_box-opts">
                      <div class="opt-btn add_btn small" @click="openAuthorize(item.goods_app_url)" v-if="item.goods_app_url">重新授权</div>
                      <a target="_blank" class="opt-btn add_btn small" :href="item.goods_app_renew_url" v-if="item.goods_app_renew_url">续订</a>
                      <a target="_blank" class="opt-btn add_btn small" :href="item.goods_app_url" v-if="item.shop_type ==7">续订</a>
                    </div>
                  </el-card>
                  <el-card class="con_box" :body-style="{padding:'8px'}" v-if="searchData.shop_type===1">
                    <p>订单应用：{{ item.order_app_name?item.order_app_name:'未订购' }}</p>
                    <p>授权状态：
                      <span class="green" v-if="item.app_order_status==1">正常</span>
                      <span class="red" v-if="item.app_order_status==2">异常</span>
                    </p>
                    <p>到期时间：{{ item.app_expire_time_order?formatTime(item.app_expire_time_order):'未订购' }}</p>
                    <div class="con_box-opts" v-if="item.order_app_url||item.order_app_renew_url">
                      <div class="opt-btn add_btn small" @click="openAuthorize(item.order_app_url)" v-if="item.order_app_url">重新授权</div>
                      <a target="_blank" class="opt-btn add_btn small" :href="item.order_app_renew_url" v-if="item.order_app_renew_url">续订</a>
                    </div>
                  </el-card>
                  <div class="opts-group">
                    <div class="add_btn" v-if="searchData.shop_type===1" @click="openMoveConfig(item)">搬家配置</div>
                    <div class="add_btn info" @click="handleCloseShop(item)">关店</div>
                  </div>
<!--                    <div style="display: flex;align-items: center;">
                      <p class="dp_status">复制额度</p>
                      <el-tooltip class="item" effect="dark" content="" placement="bottom">
                        <div slot="content" style="width: 300px">
                          购买星好货铺品工具，赠送1000个商品铺货额度，免费额度使用完需要用户购买铺品额度。
                        </div>
                        <i class="el-icon-question" style="margin-top: 11px"></i>
                      </el-tooltip>
                    </div>-->

<!--                    <p class="btn_auth red" @click="openAuthorize(item.goods_app_url)">重新授权</p>-->
<!--                    <br>-->
<!--                    <p class="dd_name">星好货打单发货</p>
                    <div v-if="item.mod_date_b>0">
                      <p class="dp_status" style="margin-top: 10px;">授权状态：
                        <span class="red" v-if="item.state_b.val==0">{{ item.state_b.text }}</span>
                        <span class="green" v-if="item.state_b.val==1">{{ item.state_b.text }}</span>
                        <a target="_blank" style="margin-left: 10px;"
                           href="https://fxg.jinritemai.com/ffa/mopen/application"><span class="red">续订</span></a>
                      </p>
                      <p class="dp_time">应用到期时间：opts{{ item.app_expire_time_b_text }}</p>
                      <p class="btn_auth red" @click="openAuthorize(item.authorize_url_b)">重新授权</p>
                    </div>
                    <div v-else>
                      <p class="btn_auth blue" @click="openAuthorize(item.authorize_url_b)">立即授权</p>
                    </div>
                    <div>
                      <p class="btn_auth blue" @click="goToEdit(item.shop_id)">搬家属性配置</p>
                    </div>-->

<!--                  </div>-->
<!--                  <div class="opts">-->
<!--                    &lt;!&ndash; <span @click="openAuthorize(item.authorize_url)">重新授权</span>-->
<!--                    <em>/</em> &ndash;&gt;-->
<!--&lt;!&ndash;                    <span @click="bindDel(item.shop_id)">关店</span>&ndash;&gt;-->
<!--                    <div class="add_btn"  @click="$refs.orderMember.open(item)">订购会员</div>-->
<!--                  </div>-->
                </li>
              </ul>
              <el-empty v-if="page_data.total==0&&!isLoading" description="未添加任何店铺"></el-empty>
            </div>
            <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit"
                        @pagination="getList"/>
          </div>
        </div>
      </div>
    </div>
    <!-- 微信店铺授权确认弹窗 -->
    <el-dialog title="添加微信店铺" width="400px" :visible.sync="confirmWechatDialog" :close-on-click-modal="false" custom-class="confirm-wechat-dialog">
      <div class="confirm-wechat-content">
        <p class="confirm-tip">是否要添加该店铺到此账号？</p>
        <p class="shop-name">{{ wechatShopInfo.shop_name }}</p>
      </div>
      <template #footer>
        <div class="confirm-footer">
          <el-button @click="confirmWechatDialog = false">取消</el-button>
          <el-button type="primary" :loading="wechatAdding" @click="confirmAddWechatShop">确认添加</el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 新增店铺 -->
    <el-dialog :title="searchData.shop_type===1 ? '选择应用' : '新增微信店铺'" width="600px" :visible.sync="authorizeDialog">
      <!-- 抖店：保持原有应用选择逻辑 -->
        <template v-if="searchData.shop_type===1">
          <div v-for="key in Object.keys(authorizeData)" :key="authorizeData[key].type">
            <div class="auth-title">{{ authorizeData[key].title }}</div>
            <div class="auth-list">
              <div class="auth-item" v-for="(item,index) in authorizeData[key].list" :key="index" >
                <el-button @click="openAuthorize(item.authorize_url)">
                  <div>
                    <div> {{item.app_name}}</div>
                    <span style="color: red;font-size: 12px;margin-top: 5px;" v-if="item.app_name=='新好货铺品'">（老店专用）</span>
                  </div>
                </el-button>
                <img src="../../assets/images/recommend.png" class="recommend" v-if="item.recommend==1">
              </div>
            </div>
          </div>
        </template>

      <!-- 微信：添加说明步骤 -->
      <div v-else class="wechat-add">
        <div class="wechat-steps">
          <p class="step-title">添加说明</p>
          <p class="step-item"><span class="step-num">1</span>点击下方按钮跳转购买服务</p>
          <p class="step-item"><span class="step-num">2</span>在微信小店服务市场「我的服务」中点击「去使用」</p>
          <p class="step-item"><span class="step-num">3</span>在使用页面复制授权码，并在下方输入</p>
        </div>

        <div class="wechat-action">
          <el-button type="primary" @click="goWechatBuy">点击跳转购买「星好货铺货」服务</el-button>
        </div>

        <div class="wechat-form">
          <el-input v-model="wechatAuthCode" placeholder="请输入授权码" style="width: 320px;">
            <template slot="prepend">授权码</template>
          </el-input>
          <el-button type="primary" :loading="wechatAdding" style="margin-left: 10px;" @click="submitWechatShop">绑定</el-button>
        </div>
        <br/>
        <br />
        <div class="wechat-action">
          <el-button type="primary" @click="goWechatBuy2">点击跳转购买「星好货打单」服务</el-button>
        </div>

        <div class="wechat-form">
          <el-input v-model="wechatAuthCode2" placeholder="请输入授权码" style="width: 320px;">
            <template slot="prepend">授权码</template>
          </el-input>
          <el-button type="primary" :loading="wechatAdding" style="margin-left: 10px;"
            @click="submitWechatShop2">绑定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 账号提醒 -->
    <el-dialog
        title="温馨提示"
        :visible.sync="dialog.accountReminders"
        width="480px"
        append-to-body
        modal-append-to-body
        :close-on-click-modal="false"
        custom-class="account_reminder_dialog_wrap"
        top="110px"
        destroy-on-close
        @closed="onAccountReminderDialogClosed"
    >
      <div class="account_reminder_dialog">
        <p class="account_reminder_tip"><i class="el-icon-warning"></i> 以下账号/应用需要您及时处理，避免影响正常采购与订单同步。</p>
        <div class="account_reminder_block" v-for="(section, sIndex) in accountReminderSections" :key="'section_' + sIndex">
          <p class="account_reminder_label">{{ section.label }}</p>
          <div class="account_reminder_item" v-for="(item, iIndex) in section.items" :key="'item_' + sIndex + '_' + iIndex">
            <span class="account_reminder_type">{{ item.text }}：</span>
            <span class="account_reminder_names">{{ item.names.join('、') }}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button @click="dialog.accountReminders = false">我知道了</el-button>
				<el-button type="primary" v-if="hasPurchaseAccountReminder" @click="goPurchaseManage">前往采购管理</el-button>
			</span>
    </el-dialog>

     <!-- 引入店铺分组管理组件 -->
    <ShopGroup
      :visible.sync="groupManageVisible"
      :batch-group-visible.sync="batchGroupVisible"
      :init-group-list.sync="groupList"
      :batch-shop-ids.sync="selectedShopIds"
      @groupChange="handleGroupChange"
    ></ShopGroup>

    <myFoot></myFoot>
    <Recharge ref="recharge" @success="onRecharge"/>
    <Record ref="record"></Record>
    <OrderMember ref="orderMember" ></OrderMember>
    <IsvDialog ref="isvDialogRef"></IsvDialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {mapActions, mapState, mapMutations} from "vuex";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import Pagination from '../../components/pagination/pagination';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import Recharge from "@/components/recharge/Recharge.vue";
import Record from "@/components/recharge/Record.vue";
import OrderMember from "@/components/orderMember/orderMember.vue";
import IsvDialog from "@/components/isvDialog/isvDialog.vue";
import ShopGroup from "@/components/shopGroup/shopGroup.vue";

export default {
  name: "ucenter",
  data() {
    return {
      isLoading: false,
      is_host: false,//是否是主账号
      list: [],
      page_data: {
        limit: 100,
        page: 1,
        total: 0,
      },
      authorizeDialog:false,
      authorize_url: '',
      authorizeData:{},
      kuaidian_authorize_url: '',
      // 微信店铺相关
      wechatAuthCode: '',
      wechatAuthCode2: '',
      wechatAdding: false,
      wechatBuyUrl: '',
      wechatBuyUrl2: 'https://store.weixin.qq.com/shop/servicemarket/detail?serviceId=3617232724823212042',
      // 微信店铺授权确认弹窗
      confirmWechatDialog: false,
      wechatShopInfo: {
        auth_code: '',
        shop_name: '',
        appid: ''
      },
      dialog: {
        authorizeDialog: false,
        productExistCategoryMisplaced:false,
        accountReminders: false,
      },
      searchData:{
        status: 0,
        // 店铺类型：1 抖店，7 微信；默认抖店
        shop_type: 1,
        shop_groupids: [],
        expire_status: '',
        shop_name: '',
        main_category: [],
      },
      service_id: '',
      itv_auto_refresh: 0,
      urlTo: '',
      sqArr: [
        {id: 1, name: '正常'},
        {id: 2, name: '失效'}
      ],

      groupManageVisible: false, // 控制分组管理组件显示
      groupList: [], // 分组列表
      groupLoading: false, // 原有分组加载状态（如需保留）
      selectedShopIds: [], // 存储勾选的店铺ID
      batchGroupVisible: false,
      main_category_list:[],

      accountReminderSections: [],
      hasPurchaseAccountReminder: false,
      reminderDialogKey: '',
      pendingPurchaseNavigate: false,
    }
  },
  created() {
    this.is_host = !(this.$store.state.login.is_host === 'false')
    this.fetchAndSaveBusinessUserId()
    this.getList()
    this.getShopMainCategory(1)
    // this.getEditUrl()
    // this.autoRefresh()
    // 检查URL参数是否有code，用于微信店铺授权回调
    this.handleWechatCode()

    this.loadAccountReminders()
    this.getDdProductExistCategoryMisplaced();//获取类目不正确的商品
  },
  destroyed() {
    if (this.itv_auto_refresh) {
      clearInterval(this.itv_auto_refresh)
    }
  },
  components: {
    Recharge,Record,
    myHead, myFoot, ucMenu, Pagination,OrderMember,IsvDialog, ShopGroup,
  },
  methods: {
    ...mapActions({
      getDdShopList: "ucenter/getDdShopList",
      addWechatShop: "ucenter/addWechatShop",
      getWechatShopAuthCode: "ucenter/getWechatShopAuthCode",
      opDdShopDel: "ucenter/opDdShopDel",
      getShopEditUrl: "ucenter/getShopEditUrl",
      getShopLevel:'ucenter/getShopLevel',
      opOrderMember:'ucenter/opOrderMember',
      opCloseShop:'ucenter/opCloseShop',
      opGetShopMainCategory: "ucenter/opGetShopMainCategory",
      getShopBoardGroupList: "shop_board/getShopBoardGroupList",
      getAccountReminders:"ucenter/getAccountReminders",
      getGoodsList: "ucenter/getGoodsList",
      getBusinessUserId: "ucenter/getBusinessUserId",
      opResetResourceState: "ucenter/opResetResourceState",
      bindWxShopByAuthCode: "wxshopShop/bindShopAction",
    }),
    ...mapMutations({
      OUT_LOGIN: "login/OUT_LOGIN"
    }),
    fetchAndSaveBusinessUserId() {
      this.getBusinessUserId({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            const businessUserId = res.data && res.data.business_user_id
            if (businessUserId) {
              localStorage.setItem('business_user_id', String(businessUserId))
            }
          } else if (res.code === 201) {
            this.OUT_LOGIN()
          }
        }
      })
    },
    loadAccountReminders(){
      this.getAccountReminders({
        success: (res) => {
          if (res.code !== 200 || !res.data) {
            return
          }
          this.showAccountReminders(res.data)
        }
      })
    },
    showAccountReminders(data){
      const groups = [
        { key: 'dd_order_app', label: '抖店订单应用' },
        { key: 'purchase_account', label: '采购账号' },
      ]
      const typeMap = [
        { field: 'expire_soon', text: '3天内到期' },
        { field: 'expired', text: '已过期' },
        { field: 'token_invalid', text: 'token失效' },
        { field: 'auth_closed', text: '授权已关闭', ddOnly: true },
      ]
      const sections = []
      let hasPurchase = false
      groups.forEach(group => {
        const block = data[group.key] || {}
        const items = []
        typeMap.forEach(typeItem => {
          if (typeItem.ddOnly && group.key !== 'dd_order_app') {
            return
          }
          const names = block[typeItem.field] || []
          if (!names.length) {
            return
          }
          items.push({ text: typeItem.text, names: [...names] })
        })
        if (items.length) {
          sections.push({ label: group.label, items })
          if (group.key === 'purchase_account') {
            hasPurchase = true
          }
        }
      })
      if (!sections.length) {
        return
      }
      const dialogKey = JSON.stringify(sections)
      if (this.reminderDialogKey === dialogKey) {
        return
      }
      this.reminderDialogKey = dialogKey
      this.accountReminderSections = sections
      this.hasPurchaseAccountReminder = hasPurchase
      this.dialog.accountReminders = true
    },
    goPurchaseManage(){
      this.pendingPurchaseNavigate = true
      this.dialog.accountReminders = false
    },
    onAccountReminderDialogClosed(){
      this.$nextTick(() => {
        const openBodyDialog = Array.from(document.querySelectorAll('body > .el-dialog__wrapper')).some((wrapper) => {
          return wrapper.style.display !== 'none' && getComputedStyle(wrapper).display !== 'none'
        })
        if (!openBodyDialog) {
          document.querySelectorAll('body > .v-modal').forEach((el) => el.remove())
          document.body.classList.remove('el-popup-parent--hidden')
          document.body.style.paddingRight = ''
        }
      })
      if (this.pendingPurchaseNavigate) {
        this.pendingPurchaseNavigate = false
        this.$router.push('./uc_pdd_manage?menuId=1')
      }
    },

    // 处理微信授权码（支持URL参数传递或手动输入）
    handleWechatCode(manualCode) {
      let code = manualCode
      // 如果没有传入code，则从URL参数获取
      if (!code) {
        const urlParams = new URLSearchParams(window.location.search)
        code = urlParams.get('code')
        if (code) {
          // 清除URL中的code参数，避免刷新后重复处理
          const url = new URL(window.location.href)
          url.searchParams.delete('code')
          window.history.replaceState({}, '', url.toString())
        }
      }
      if (!code) return

      // 显示全屏loading
      const loading = this.$loading({
        lock: true,
        text: '正在获取授权信息...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.9)'
      })

      // 延迟1秒后请求接口
      setTimeout(() => {
        this.getWechatShopAuthCode({
          data: { code },
          success: (res) => {
            loading.close()
            if (res.code === 200 && res.data) {
              // 保存返回的店铺信息
              this.wechatShopInfo = {
                auth_code: res.data.auth_code || '',
                shop_name: res.data.shop_name || '',
                appid: res.data.appid || ''
              }
              // 切换到微信店铺列表
              this.searchData.shop_type = 7
              // 打开确认弹窗
              this.confirmWechatDialog = true
            } else {
              this.$message({ message: res.msg || res.message || '获取授权信息失败', type: 'error' })
            }
          }
        })
      }, 500)
    },
    // 确认添加微信店铺
    confirmAddWechatShop() {
      if (!this.wechatShopInfo.auth_code) {
        this.$message({ message: '授权码为空', type: 'warning' })
        return
      }
      if (this.wechatAdding) return
      this.wechatAdding = true
      this.addWechatShop({
        data: { auth_code: this.wechatShopInfo.auth_code },
        success: (res) => {
          this.wechatAdding = false
          if (res.code === 200) {
            this.$message({ message: res.msg || '添加成功', type: 'success' })
            this.confirmWechatDialog = false
            // 重置店铺信息
            this.wechatShopInfo = { auth_code: '', shop_name: '', appid: '' }
            // 刷新微信店铺列表
            this.getList()
          } else {
            this.$message({ message: res.msg || res.message || '添加失败', type: 'error' })
          }
        }
      })
    },
    openRecord(){
      this.$refs.record.show()
    },
    openAddShop() {
      // 打开新增抖店/微信弹窗
      this.authorizeDialog = true
      if (this.searchData.shop_type === 7) {
        // 切到微信时重置授权码表单
        this.wechatAuthCode = ''
        this.wechatAuthCode2 = ''
      }
    },
    //自动刷新
    autoRefresh() {
      let that = this
      that.itv_auto_refresh = setInterval(function () {
        that.getList(false)
      }, 5000)

    },
    getEditUrl() {
      this.getShopEditUrl({
        data: {}, success: (res) => {
          if (res.code === 200) {
            this.urlTo = res.data.url
          }
        }
      })
    },
    goToEdit(id) {
      window.open(this.urlTo + '&shopId=' + id)
      // urlTo
    },
    openMoveConfig(item) {
      const shopId = Number(item.shop_id || 0)
      if (!shopId) {
        this.$message.error('店铺信息异常，缺少本地店铺ID')
        return
      }
      this.$router.push({ path: '/uc_doudian_move_config', query: { shop_id: shopId } })
    },
    bindShopChange(e){
      this.searchData.status = e;
      this.getList()
    },
    // 切换店铺类型：1 抖店，7 微信
    bindShopTypeChange(type) {
      if (this.searchData.shop_type === type) return
      this.searchData.shop_type = type
      this.page_data.page = 1
      this.selectedShopIds = []
      this.getShopMainCategory(type)
      this.getList()
    },
    resetSearch(){
      this.page_data.page = 1
      this.searchData = {}
      this.searchData.shop_groupids = []
      this.getList()
    },
    onSearch(){
      this.page_data.page = 1
      this.getList()
    },
    //获取店铺列表
    getList(showLoading = true) {
      if (showLoading) this.isLoading = true
      let param = {page_size: this.page_data.limit, page: this.page_data.page}
      // 仅传递店铺类型给接口，1 抖店，7 微信；默认抖店
      if (this.searchData.shop_type) {
        param.shop_type = this.searchData.shop_type
        param.expire_status = this.searchData.expire_status
        if (this.searchData.shop_groupids){
            param.shop_groupids = this.searchData.shop_groupids
        }
        if (this.searchData.main_category){
            param.main_category = this.searchData.main_category
        }
        if (this.searchData.shop_name){
            param.shop_name = this.searchData.shop_name
        }
      }

      this.getDdShopList({
        data: param, success: (res) => {
          if (res.code === 200) {
            this.list = res.data.list.list
            this.page_data.total = res.data.list.total
            this.authorize_url = res.data.Authorization_url
            this.authorizeData={}
            if (param.shop_type===1) {
              res.data.Authorization_url.forEach(item => {
                if (!this.authorizeData[item.app_type]) {
                  this.authorizeData[item.app_type] = {
                    type: item.app_type,
                    title: item.app_type === 'order' ? '订单应用' : item.app_type === 'product' ? '商品应用' : '',
                    list: []
                  }
                }
                this.authorizeData[item.app_type].list.push(item)
              })
            }
            if (res.data.weChat_url) {
              this.wechatBuyUrl = res.data.weChat_url
            }

          } else {
            this.$message({message: res.message, type: 'error',});
          }
          if (res.code === 201) {
            this.OUT_LOGIN()
          }
          this.isLoading = false
        }
      })
      //加载分组信息
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
            if (res.code === 200) {
                this.groupList = res.data || [];
            } else {
                this.$message.error(res.message || '获取分组失败');
            }
        }
      });
    },

     formatTime(time){
      if(!time) return ''
      const date = new Date(time * 1000)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hour = date.getHours()
      const minute = date.getMinutes()
      const second = date.getSeconds()

      const formatNumber=(n)=>{
        n = n.toString()
        return n[1] ? n : `0${n}`
      }

       return `${[year, month, day].map(formatNumber).join('-')} ${[hour, minute, second].map(formatNumber).join(':')}`
    },

    //弹窗授权 废
    bindAdd() {
      this.service_id = ''
      this.dialog.authorizeDialog = true
    },
    //确定授权
    doAdd() {
      let service_id = this.service_id
      if (service_id == '') {
        this.$message({message: '请输入抖店service id', type: 'info',});
        return
      }
      let authorize_url = this.authorize_url + service_id
      this.openAuthorize(authorize_url)
      this.dialog.authorizeDialog = false
    },
    toRecharge(val) {
      this.$refs.recharge.show(val)
    },
    //抖店授权跳转
    openAuthorize(url) {
      this.authorizeDialog=false
      window.open(url, '_blank')
    },
    // 跳转微信购买/开通地址
    goWechatBuy() {
      if (this.wechatBuyUrl) {
        window.open(this.wechatBuyUrl, '_blank')
      } else {
        this.$message({message: '暂未配置微信购买地址', type: 'warning'})
      }
    },
    goWechatBuy2() {
      if (this.wechatBuyUrl2) {
        window.open(this.wechatBuyUrl2, '_blank')
      } else {
        this.$message({message: '暂未配置微信购买地址', type: 'warning'})
      }
    },
    // 提交微信授权码添加店铺（手动输入code，走handleWechatCode流程）
    submitWechatShop() {
      if (!this.wechatAuthCode) {
        this.$message({message: '请输入授权码', type: 'warning'})
        return
      }
      if (this.wechatAdding) return
      // 关闭新增弹窗，使用手动输入的code走handleWechatCode流程
      this.authorizeDialog = false
      this.handleWechatCode(this.wechatAuthCode)
      this.wechatAuthCode = ''
    },
    // 提交「星好货打单」授权码，对接 /api/v1/wxshop/shop/bind
    submitWechatShop2() {
      if (!this.wechatAuthCode2) {
        this.$message({message: '请输入授权码', type: 'warning'})
        return
      }
      if (this.wechatAdding) return
      this.handleWechatCode2(this.wechatAuthCode2)
    },
    /**
     * 星好货打单授权码绑定微信小店
     * POST /api/v1/wxshop/shop/bind  body: { authCode }
     */
    handleWechatCode2(authCode) {
      const code = (authCode || '').trim()
      if (!code) {
        this.$message({ message: '请输入授权码', type: 'warning' })
        return
      }
      if (this.wechatAdding) return
      this.wechatAdding = true
      this.bindWxShopByAuthCode({
        data: { authCode: code,xhh_business_user_id: localStorage.getItem('business_user_id')},
        success: (res) => {
          this.wechatAdding = false
          if (res.code === 200) {
            this.$message({ message: res.msg || res.message || '绑定成功', type: 'success' })
            this.authorizeDialog = false
            this.wechatAuthCode2 = ''
            this.searchData.shop_type = 7
            this.getList()
          } else {
            this.$message({ message: res.msg || res.message || '绑定失败', type: 'error' })
          }
        },
        error: () => {
          this.wechatAdding = false
          this.$message({ message: '绑定失败，请稍后重试', type: 'error' })
        }
      })
    },
    onRecharge() {
      this.getList()
    },
    handleCloseShop(item){
      let params = {
        mer_shop_id:item.shop_id,
        password:''
      }
      this.$prompt('请输入登录密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType:'password',
        inputValidator: (value) => {
          if (!value||!value.trim()) {
            return '请输入密码'; // 返回字符串，显示为错误信息
          }
          return true; // 校验通过
        }
      }).then(({ value }) => {
        params.password = value
        this.$confirm('是否确认关店？店铺关闭后，之前有关店铺的所有操作均会丢失，无法找回。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log("params:",params)
          this.opCloseShop({
            data: params, success: (res) => {
              if (res.code === 200) {
                this.$message({message: res.msg, type: 'success',});
                this.getList()
              } else {
                this.$message({message: res.msg, type: 'error',});
              }
            }
          })
        }).catch((res) => {
          console.log(res)
        });

      }).catch(() => {

      });
    },
    handleRadioClick(e) {
        // 只有点击在 input 元素上时才处理（排除点击文字 label 的情况，防止逻辑冲突）
        if (e.target.tagName === 'INPUT') {
            const clickedValue = e.target._value;
            if (this.searchData.expire_status === clickedValue) {
                this.searchData.expire_status = ''; // 置空，实现取消
            } else {
                this.searchData.expire_status = clickedValue;
            }
            this.onSearch();
        }
    },
    handleGroupRadioClick(e) {
        // 只有点击在 input 元素上时才处理（排除点击文字 label 的情况，防止逻辑冲突）
        if (e.target.tagName === 'INPUT') {
            const clickedValue = e.target._value;
            if (this.searchData.expire_status === clickedValue) {
                this.searchData.expire_status = ''; // 置空，实现取消
            } else {
                this.searchData.expire_status = clickedValue;
            }
            this.onSearch();
        }
    },
    // 打开分组管理弹窗
    openShopGroupManageDialog() {
        // if(this.$store.state.login.user_level == 9) {
        //     this.$message.error('普通会员无法使用分组');
        //     return;
        // }
        this.groupManageVisible = true;
    },
    // 接收分组变化通知
    handleGroupChange() {
      //加载分组信息
      this.getList()
    },
    // 全选
    selectAll() {
        this.selectedShopIds = this.list.map(item => item.shop_id)
    },
    // 反选
    unSelectAll() {
        let allIds = this.list.map(item => item.shop_id)
        this.selectedShopIds = allIds.filter(shop_id => !this.selectedShopIds.includes(shop_id))
    },
    // 打开批量设置分组
    openBatchGroupDialog() {
        // if(this.$store.state.login.user_level == 9) {
        //     this.$message.error('普通会员无法使用分组');
        //     return
        // }
        this.batchGroupVisible = true
        this.batchGroupId = ''
    },
    setChange(val) {
        // if(this.$store.state.login.user_level == 9 && this.searchData.shop_groupids) {
        //     this.searchData.shop_groupids = []
        //     this.$message.error('普通会员无法使用分组');
        //     return
        // }
        this.getList()
    },
    getShopMainCategory(shop_type) {
        this.opGetShopMainCategory({
            data: {'shop_type': shop_type}, success: (res) => {
              if (res.code === 200) {
                this.main_category_list = res.data || []
              } else {
                this.$message({message: res.msg, type: 'error',});
              }
            }
        })
    },
    /**
     * —— 类目不确定商品 —— */
    getDdProductExistCategoryMisplaced(){//获取类目不正确的商品
      let param = {limit:1, page:1, state:13}
      this.getGoodsList({
        data: param, success: (res) => {
          if (res.code === 200) {
            if(res.data?.pagination?.total>0){
              this.$refs.isvDialogRef.show()
            }
          } else {
            this.$message({message: res.msg, type: 'error',});
          }
          this.isLoading = false
        }
      })
    },

    /**
     * —— 素材容量不足 ——*/
    bindResourceTips() {
      let that = this
      that.$alert('素材库容量不足会导致无法正常铺货，请登录抖店后台素材库扩容后在点重置按钮【点击去扩容按钮登录抖店滚到底部左下角扩容】。', '说明', {
        confirmButtonText: '去扩容',
        cancelButtonText: '了解',
        showCancelButton: true,
        type: 'warning'
      }).then((res) => {
        window.open('https://fxg.jinritemai.com/ffa/creative/material_center')
      }).catch((res) => {
      });
    },
    bindResourceState(shop_id) {
      let that = this
      that.$confirm('确认店铺素材库已扩容了吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        if (that.isLoading) return
        that.isLoading = true
        let param = {shop_id: shop_id}
        that.opResetResourceState({
          data: param, success: (res) => {
            if (res.code === 200) {
              // console.log('get shop list',res)
              that.$message({message: res.msg, type: 'success',});
              that.getList()
            } else {
              that.$message({message: res.msg, type: 'error',});
            }
            that.isLoading = false
          }
        })
      }).catch((res) => {
        console.log(res)
      });
    }

  }
}
</script>

<style scoped>
.d-b-c{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-shrink-0{
  flex-shrink: 0;
}

/* 整体行布局 */
.action-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 分组操作区 */
.group-action {
  display: flex;
  align-items: center;
  margin-left: 16px;
}

/* 分组文字 */
.group-label {
  font-size: 13px;
  color: #666;
  margin-right: 4px;
  font-family: math;
}

/* 按钮紧凑并拢 */
.group-action .el-button {
  padding: 7px 17px !important;
  margin-left: 4px !important;
}
.dp_list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 12px;
}
.header-right {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 10;
}
.group-tag {
  margin-right: 4px;
}
.shop-check {
  margin: 0;
}
/* 微信店铺授权确认弹窗样式 */
.confirm-wechat-content {
  text-align: center;
  padding: 10px 0 0;
}
.confirm-wechat-content .confirm-tip {
  font-size: 15px;
  color: #333;
  margin-bottom: 16px;
}
.confirm-wechat-content .shop-name {
  font-size: 18px;
  font-weight: bold;
  color: #f0413e;
}
.confirm-footer {
  text-align: center;
}

.auth-list{
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.auth-list .el-button+.el-button {
  margin-left: 0 !important;
}
.auth-item{
  position: relative;
}
.auth-item .el-button{
  height: 100%;
  padding: 12px 24px;
}
.auth-item .recommend{
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
  border-radius: 4px 0 0 0;

}

.add_btn{
  width: fit-content;
  padding:2px 5px;
  border: 1px solid #ff4400;
  color: #ff4400;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
}
.add_btn:hover{
  background: #ff4400;
  color: #fff;
}


.center {
  display: flex;
  flex: 1;
}


.dianpu_main {
  padding: 28px 40px;
  min-height: 500px;
}

.dianpu_main .dp_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dp_title .add_new {
  width: 74px;
  height: 34px;
  box-sizing: border-box;
  border-radius: 6px;
  border: 1px solid var(--red);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color:var(--red);
  cursor: pointer;
  background: #fff;
  margin-left: 10px;
}

.auth_btn {
  display: flex;
  align-items: center;
}

.dianpu_main .dp_list {
  padding-top: 8px;
 /* display: flex;
  flex-wrap: wrap;*/
  display: grid;
  grid-template-columns:repeat(auto-fill, minmax(290px, 1fr));
  grid-gap: 28px;
}

/* 微信新增店铺弹窗样式 */
.wechat-add {
  padding: 10px 0 0;
}
.wechat-steps {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 20px;
}
.wechat-steps .step-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
}
.wechat-steps .step-item {
  font-size: 14px;
  color: #666;
  line-height: 2;
  display: flex;
  align-items: center;
}
.wechat-steps .step-num {
  width: 20px;
  height: 20px;
  background: var(--red);
  color: #fff;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-right: 10px;
  flex-shrink: 0;
}
.wechat-action {
  margin-bottom: 20px;
}
.wechat-form {
  display: flex;
  align-items: center;
}

.dp_list > li {
 /* width: 290px;*/
  flex: 1;
  min-height: 200px;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  padding: 12px;
  position: relative;
 /* margin: 14px 14px 0 0;*/
}

.dp_list > li:nth-child(3n) {
  margin-right: 0;
}

.dp_list > li .logo {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  background: #eee;
  overflow: hidden;
  margin-right: 10px;
}
.dp_list > li .vip_name {
  font-size: 14px;
  color: #aa007f;
  font-weight: bold;
  line-height: 1.2;
  margin-top: 5px;
}

.dp_list > li .vip_name .vip_btn {
  font-weight: normal;
  cursor: pointer;
  color: #f0413e;
  margin-left: 6px;
  font-size: 12px;
}

.dp_list > li .dp_name {
  line-height: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.dp_list .dp_list-header {
  display: flex;
  align-items: center;
  min-height: 76px;
}
.dp_list > li .con_box {
  flex: 1;
  margin-top: 10px;
  font-size: 12px;
}
.dp_list > li .con_box p~p{
  margin-top: 4px;
}
.dp_list .con_box .con_box-opts {
 display: flex;
  flex-wrap: wrap;
}
.dp_list .con_box .con_box-opts .opt-btn{
  margin-right: 10px;
  margin-top: 4px;
}

.dp_list > li .opts {
  position: absolute;
  bottom: 15px;
  right: 15px;
  z-index: 2;
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
}

.btn_auth {
  cursor: pointer;
  font-size: 12px;
  margin-top: 8px;
}

.btn_auth:hover {
  color: #f0413e;
}
/*--自定义按钮--*/
.add_btn{
  width: fit-content;
  padding:2px 5px;
  border: 1px solid #ff4400;
  color: #ff4400;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
}
.add_btn:hover{
  background: #ff4400;
  color: #fff;
}
.add_btn.small{
  font-size: 12px;
  line-height: 14px;
}
/*--自定义按钮--*/
/*店铺操作*/
.opts-group{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 10px;
}
.add_btn.info{
  border: none;
  background: #bbb1a9;
  color: #fff;
}
.add_btn.info:hover{
  background: #bbb1a9;
  color: #fff;
}
/*店铺操作*/

/*--添加店铺弹窗--*/
.auth-list{
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 30px;
}
.auth-list .el-button+.el-button {
  margin-left: 0 !important;
}
.auth-title{
  font-weight: bold;
  margin-bottom: 10px;
}
.auth-item{
  position: relative;
}
.auth-item .el-button{
  height: 100%;
  padding: 12px 24px;
}
.auth-item .recommend{
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
  border-radius: 4px 0 0 0;
}
/*--添加店铺弹窗--*/

/* —— 账号提醒弹窗 ——*/
.account_reminder_dialog{line-height: 1.6;color: #333;}
.account_reminder_tip{display: flex;align-items: flex-start;font-size: 14px;color: #666;margin-bottom: 16px;}
.account_reminder_tip .el-icon-warning{color: #e6a23c;font-size: 18px;margin-right: 8px;margin-top: 2px;flex-shrink: 0;}
.account_reminder_block{margin-bottom: 16px;padding: 12px 14px;background: #fff9f0;border-radius: 6px;border: 1px solid #ffe8cc;}
.account_reminder_block:last-child{margin-bottom: 0;}
.account_reminder_label{font-size: 14px;font-weight: bold;color: #333;margin-bottom: 8px;}
.account_reminder_item{font-size: 13px;color: #666;line-height: 22px;margin-top: 4px;}
.account_reminder_type{color: #f0413e;}
.account_reminder_names{color: #333;}
/* —— 账号提醒弹窗 ——*/
</style>
<style scoped>

.el-select-dropdown__item.selected, .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
  color: var(--red);
}

.el-button {
  color: #333;
  border-color: #ddd;
}

.el-button--small {
  padding: 7px 15px;
}


/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__inner:hover, .el-checkbox__input.is-focus .el-checkbox__inner, .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus, .el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner {
  border-color: var(--red);
}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked + .el-checkbox__label, .el-pager li.active, .el-pagination button:hover, .el-pager li:hover {
  color: var(--red);
}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--red);
}

.el-button:focus, .el-button:hover {
  border-color: var(--red);
  color: var(--red);
  background: #fff;
}

.el-button--primary {
  background: var(--red) !important;
  color: #fff !important;
  border-color: #fff;
}

.el-button--primary:focus, .el-button:hover {
  border-color: var(--red);
}

.el-loading-spinner .el-loading-text {
  color: var(--red);
}

.el-loading-spinner .path {
  stroke: var(--red);
}
.dp_list > li .logo .coverimg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/deep/.badge-num {
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 19 !important;
}
/deep/.el-checkbox-button__inner {
  position: relative;
}
.w220 {
  width: 220px;
}
/* 让 el-select 变成 tag 风格 */
.tag-select {
  width: auto;
}
.tabs_wrap{width: 100%;padding: 16px 0;display: flex;gap: 12px;}
.radio_wrap{margin: 5px 0;}
.tabs_wrap .tab{padding: 10px 28px;border-radius: 20px;cursor: pointer;font-size: 15px;color: #666;background: #f5f5f5;border: 1px solid #e0e0e0;transition: all 0.2s ease;}
.tabs_wrap .tab:hover{background: #fff0ef;border-color: #ffccc7;color: #f0413e;}
.tabs_wrap .tab.active{font-weight: bold;color: #fff;background: linear-gradient(135deg, #f0413e, #ff6b5a);border-color: transparent;box-shadow: 0 2px 8px rgba(240,65,62,0.3);}
</style>
